<template>
  <div class="content">
    <div class="search"></div>
    <div class="income">
      <div class="date">
        <div class="time">{{date}}</div>
        <div class="time-icon" @click="openPicker"><img :src="public_path + '/static/images/icon_date.svg'" alt=""></div>
      </div>
      <div class="total-amount">
        <span style="opacity: 0.5">收入金额：</span>
        <span>{{total_amount}}</span>
        <span style="font-size: .26rem;color: #F58423">{{state_cn}}</span>
      </div>
    </div>
    <div v-if="dev_list.length" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
      <div class="income-dev" v-for="dev in dev_list" :key="dev.soft_sn" @click="toDetail(dev.soft_sn)">
        <div class="dev-info">
          <div class="dev-soft">设备编号：{{dev.soft_sn}}</div>
          <div class="owner-info">
            <span>所属教练：{{dev.owner_name}}</span>
            <span>电话：{{dev.owner_mobile}}</span>
          </div>
        </div>
        <div class="dev-amount">
          <span>+{{dev.amount.toFixed(2)}}</span>
          <img :src="public_path + '/static/images/arrow_right.svg'" alt="" class="right-img">
        </div>
      </div>
    </div>
    <div>
      <mt-datetime-picker type="date" ref="picker" year-format="{value} 年" v-model="startDate" month-format="{value} 月" @confirm="handleConfirm" ></mt-datetime-picker>
    </div>
  </div>
</template>
<script>
import { getIncomeByDev } from '@/http/api'
import { DatetimePicker } from 'mint-ui'
import moment from 'moment'
import Vue from 'vue'
import infiniteScroll from 'vue-infinite-scroll';
Vue.use(infiniteScroll)
Vue.component(DatetimePicker.name, DatetimePicker)

export default {
  data () {
    return {
      state_cn: '',
      total_amount: 0,
      page: 1,
      date: '',
      startDate: new Date(),
      ym: '',
      public_path: process.env.PUBLICK_PATH,
      dev_list: [],
      total_page: 0
    }
  },
  mounted () {
    this.date = this.startDate.getFullYear() + '年' + (this.startDate.getMonth() + 1) + '月'
    this.ym = this.startDate.getFullYear() + (this.startDate.getMonth() + 1 < 10 ? '0' : '') + (this.startDate.getMonth() + 1)
    this.getIncomeByDev()
  },
  methods: {
    loadMore () {
      this.page += 1
      if (this.page > this.total_page) {
        return
      } else {
        console.log(this.page)
        this.getIncomeByDev()
      }
    },
    openPicker () {
      this.$refs.picker.open()
    },
    handleConfirm (data) {
      console.log(0)
      let date = moment(data).format('YYYY.MM.DD')
      let dateTime = date.split('.')
      this.ym = dateTime[0] + dateTime[1]
      this.date = dateTime[0] + '年' + dateTime[1] + '月'
      this.dev_list = []
      this.page = 1,
      this.total_page = 0
      this.getIncomeByDev()
    },
    getIncomeByDev () {
      getIncomeByDev({
        ym: this.ym,
        page: this.page,
        limit: 20,
        token: localStorage.token
      }).then(res => {
        console.log(res)
        if (res.code == 0) {
          let total_num = JSON.parse(localStorage.userInfo).dev_num
          this.total_amount = (res.data.total_amount).toFixed(2)
          this.state_cn = res.data.state_cn
          this.dev_list = res.data.data ? this.dev_list.concat(res.data.data) : this.dev_list
          this.total_page = Math.ceil(total_num / 20)
        }
      })
    },
    toDetail (softsn) {
      this.$router.push({
        path: '/incomedetail',
        query: {softsn: softsn, ym: this.ym}
      })
    }
  }
}
</script>

<style>
.picker-items .picker-slot-center:nth-child(3) {
  flex:0 0 0%!important;
  background-color:red;
}
</style>

<style lang="scss" scoped>
.content {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 0;
  overflow: auto;
  background: #f5f5f5;
  .income {
    padding: .22rem .3rem;
    background: #fff;
    .date {
      display: -webkit-flex;
      display: flex;
      align-items: center;
      height: .6rem;
      .time {
        font-size: .34rem;
        color: #02B389;
        flex: 1;
        text-align: left;
      }
      .time-icon {
        flex: 1;
        text-align: right;
        img {
          width: .34rem;
          // height: .28rem;
          display: inline-block;
        }
      }
    }
    .total-amount {
      display: -webkit-flex;
      display: flex;
      align-items: center;
      margin-top: .2rem;
      padding-bottom: .2rem;
      span {
        font-size: .3rem;
        color: #000;
        font-weight: 500;
        &:nth-child(3) {
          margin-left: .3rem;
        }
      }
    }
  }
  .income-dev {
    padding: .34rem .3rem;
    margin-top: .2rem;
    background: #fff;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    .dev-info {
      .dev-soft {
        font-size: .30rem;
        color: #000;
      }
      .owner-info {
        margin-top: .2rem;
        color: rgba(0, 0, 0, .5);
        span {
          font-size: .26rem;
          margin-right: .38rem;
        }
      }
    }
    .dev-amount {
      flex: 1;
      text-align: right;
      span {
        color: #F58423;
        font-size: .3rem;
        font-weight: 500;
      }
      .right-img {
        width: .14rem;
        height: .25rem;
        margin-left: .1rem;
      }
    }
  }
  .picker-bg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
  }
  .pciker-time {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: #fff;
    .head {
      height: 1rem;
      line-height: 1rem;
      display: -webkit-flex;
      display: flex;
      padding: 0 .3rem;
      border-bottom: 1px solid #EBEBEB;
      .clear {
        flex: 1;
        font-size: .26rem;
        text-align: left;
        color: rgba(51, 51, 51, .6);
      }
      .title {
        flex: 1;
        font-size: .32rem;
        text-align: center;
      }
      .sure {
        flex: 1;
        text-align: right;
        font-size: .26rem;
        color: #02B389;
      }
    }
    .time-value {
      height: .88rem;
      line-height: .88rem;
      padding: 0 .3rem;
      span {
        width: 100%;
        text-align: center;
        font-size: .28rem;
        color: #02B389;
        display: inline-block;
        border-bottom: 1px solid #02B389;
      }
    }
    .pic {
      padding: .3rem 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/income/IncomeByDev.vue